import { useTranslation } from 'react-i18next';

// Import styles
import { InputContainer, InputWrapper, InputStyled, Label, Error } from './styles';

// Import types
import type { DefaultFieldType, FormFieldProps } from 'types/views/form';

// Import utilities
import { useHookFormField } from 'components/utilities';

type Props = FormFieldProps<DefaultFieldType>;

const Input = (props: Props) => {
	const { t } = useTranslation();
	const { field, fieldState, isError, isDisabled } = useHookFormField(props);

	return (
		<InputContainer>
			<InputWrapper>
				<InputStyled
					placeholder=" "
					value={field.value}
					id={field.name}
					name={field.name}
					onBlur={field.onBlur}
					onChange={field.onChange}
					disabled={isDisabled}
					isError={isError}
					type={props.type}
					modifiers={props.modifiers}
					autoComplete={props.autoComplete}
				/>

				<Label modifiers={props.modifiers}>
					{t(props.label)} {props.required && '*'}
				</Label>
			</InputWrapper>

			{isError && <Error modifiers={props.modifiers}>{t(fieldState.error?.message || '')}</Error>}
		</InputContainer>
	);
};

export default Input;
